import {
  EXERCISE_KEY,
  getByIdExerciseSelector
  ,
  getValueReduxUtil
} from '@gymaholic/packages'
import Button from 'components/Button'
import Text from 'components/Text.js'
import { View } from 'components/View'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import ExerciseMediaImage from 'containers/ExerciseMediaImage'
import { Image } from 'components/Image'
import pushRouterAction from 'modules/router/actions/push'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import getSlugExerciseNameUtil from 'modules/exercise/utils/get-slug/index.js'

export default function ExerciseCard ({ id }) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const exercise = useSelector(getByIdExerciseSelector(id))
  const exerciseName = getValueReduxUtil(exercise, EXERCISE_KEY.NAME)
  const slug = getSlugExerciseNameUtil(exerciseName)
  const dispatch = useDispatch()

  const handleClickExercise = (id, slug) => {
    dispatch(
      pushRouterAction({
        pathname: interpolateRouteUtil(
          ROUTE_PATH.VIEW_EXERCISE_SLUG,
          {
            id,
            slug
          }
        )
      })
    )
  }

  const width = isSmallScreen ? '200px' : '400px'
  return (
    <Button
      onClick={() => handleClickExercise(id, slug)}
      style={{
        width,
        height: isSmallScreen ? '170px' : '340px',
        maxWidth: 'unset',
        display: 'flex'
      }}
    >
      <View>
        <View style={{
          width,
          height: isSmallScreen ? '120px' : '240px'
        }}
        >
          <ExerciseMediaImage
            id={id}
            aspectRatio={Image.ASPECT_RATIO.WIDE}
          />
        </View>
        <Text
          c='#000000'
          mt
          fs='14px'
          style={{ textAlign: 'left' }}
        >{exerciseName}
        </Text>
      </View>
    </Button>
  )
}
